import React, { useState } from 'react'
import '../emailcode/EmailCode.css'
import { Link, useNavigate } from 'react-router-dom'
import useApi from '../../customHook/useApi';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import {  toast } from 'react-toastify';

const EmailCode = () => {
    const navigate = useNavigate();
    const [otp, setOtp] = useState(['', '', '', '', '', '']); // To track OTP input
    const { postFormData, data, error, loading } = useApi('https://codezens.com/luststory/index.php/api/'); // base URL of the API

    const { userId } = useSelector((state) => state.user);

    useEffect(() => {
        if (!userId) {
            navigate('/signup')
        }
    }, []);

    // Validate OTP input
    const validateOtp = () => {
        const otpString = otp.join('');
        if (otpString.length < 6) {
            toast.error('Please enter all 6 digits of the OTP.');
            // setErrorMessage('Please enter all 6 digits of the OTP.');
            return false;
        }

        if (!/^\d+$/.test(otpString)) {
            toast.error('OTP must be a number.');
            // setErrorMessage('OTP must be a number.');
            return false;
        }

        return true;
    };

    // Handle OTP input change
    const handleOtpChange = (e, index) => {
        const newOtp = [...otp];
        newOtp[index] = e.target.value;
        setOtp(newOtp);
    };

    // Handle form submit and call the API
    const handleSubmit = async (e) => {
        e.preventDefault();

        if(!validateOtp()){
            return;
        }

        // Join OTP to create the full OTP string
        const otpCode = otp.join('');

        // const formData = new FormData();
        // formData.append('user_id', 41);
        // formData.append('otp', otpCode);

        // Call the API with the OTP and user ID (you can replace 28 with a dynamic user ID)
        try {
            await postFormData(`check_otp`, { user_id: userId, otp: otpCode });
            navigate('/create-password');
        } catch (err) {
            console.error('Error:', err);
        }
    };

    return (
        <div className='email-code-section w-100 position-relative'>
            <Link rel='stylesheet' to="/signup" className='back-btn'>Back</Link>
            <div className='email-code-box d-flex flex-wrap align-content-center justify-content-center'>
                <h6 className='text-center'>Enter code sent to your email</h6>
                <div className='email-code-form w-100'>
                    <form className='d-flex align-items-center justify-content-between'>
                        {otp.map((digit, index) => (
                            <div key={index} className="input-box">
                                <input
                                    type="text"
                                    className="form-control text-center"
                                    maxLength="1"
                                    value={digit}
                                    onChange={(e) => handleOtpChange(e, index)}
                                    placeholder=""
                                />
                            </div>
                        ))}
                        <div class="input-box btn-box" onClick={handleSubmit}>
                            {/* <Link rel='stylesheet' to="/create-password"> */}
                            <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.605 18.3076L20.4127 13.4999L15.605 8.69223" stroke="#787486" stroke-linecap="round" stroke-linejoin="round" /><path d="M20.4122 13.5H6.95068" stroke="#787486" stroke-linecap="round" stroke-linejoin="round" /><path d="M26.1816 13.5C26.1816 6.59635 20.5853 1 13.6816 1C6.77808 1 1.18164 6.59635 1.18164 13.5C1.18164 20.4036 6.77808 26 13.6816 26C20.5853 26 26.1816 20.4036 26.1816 13.5Z" stroke="#787486" stroke-linecap="round" stroke-linejoin="round" /></svg>
                            {/* </Link> */}
                        </div>
                    </form>
                    <p className='text-center'><Link rel='stylesheet' >Resend code</Link></p>
                </div>
            </div>
        </div>
    )
}

export default EmailCode
